// extracted by mini-css-extract-plugin
module.exports = {"summary":"AppVersions_summary__GY0Tv","tooltip":"AppVersions_tooltip__ghbqx"};